import { ProfileTypes } from './actionTypes';

const initialState = {
  profileData: {},
  error: '',
  success: '',
  isLoading: false,
};

const profile = (state = initialState, action: any) => {
  switch (action.type) {
    case ProfileTypes.EDIT_PROFILE:
      state = { ...state };
      break;
    case ProfileTypes.PROFILE_SUCCESS:
      return {
        ...state,
        success: 'SUCCESS',
        profileData: action.payload,
      };
    case ProfileTypes.PROFILE_ERROR:
      state = {
        ...state,
        error: action.payload,
        profileData: {},
      };
      break;
    case ProfileTypes.RESET_PROFILE_FLAG:
      state = { ...state, success: '' };
      break;

    case ProfileTypes.UPDATE_PROFILE_PICTURE:
      console.log(action.payload, 'Entro al reducer');
      return {
        ...state,
        isLoading: true,
      };

    case ProfileTypes.UPDATE_PROFILE_PICTURE_SUCCESS:
      console.log(action.payload, 'Entro al reducer');
      return {
        ...state,
        isLoading: false,
        profileData: {
          ...state.profileData,
          URL_FOTO_PERFIL: action.payload,
        },
      };
    default:
      break;
  }
  return state;
};

export default profile;
